import React from "react";
import { base_api_url } from "../../../environment.jsx";
import axios from "axios";
import Swal from "sweetalert2";
import { useEffect, useState } from 'react';
import withReactContent from "sweetalert2-react-content";
import PropTypes from 'prop-types';
//import { BiDrink } from "react-icons/bi";
import './AddEtiquetteDrawer.css';

const AddEtiquette = ({ show, onFormSubmit, onClose, editMode = false, etiquetteData = null }) => {
    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;

    // Pour récupérer les éléments du formulaire
    const [formData, setFormData] = useState({
        "code": "",
        "description": "",
        "id_restaurant": ideresto
    });

    // Use Effect pour populate le formulaire en mode édition
    useEffect(() => {
        if (editMode && etiquetteData) {
            setFormData({
                code: etiquetteData.code || etiquetteData.nom || "",
                description: etiquetteData.description || "",
                id_restaurant: ideresto
            });
            // Si l'étiquette a un statut, le définir
            setIsActive(etiquetteData.statut !== 'Inactive');
        }
    }, [editMode, etiquetteData, ideresto]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const resetForm = () => {
        setFormData({
            code: "",
            description: "",
            id_restaurant: ideresto
        });
        setIsActive(true);
    };

    // Pour la soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = JSON.parse(localStorage.getItem("user"))?.access_token;

            // On soumet seulement le code (nom) et la description
            const dataToSubmit = {
                code: formData.code,
                description: formData.description,
                id_restaurant: ideresto
            };

            console.log("Form data to submit:", dataToSubmit);

            let response;

            if (editMode && etiquetteData?.id_etiquette) {
                // Update existing etiquette
                response = await axios.put(`${base_api_url}api/etiquette/${etiquetteData.id_etiquette}`,
                    dataToSubmit,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                console.log("Etiquette updated:", response.data);
            } else {
                // Create new etiquette
                response = await axios.post(`${base_api_url}api/etiquette`,
                    dataToSubmit,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                console.log("Etiquette created:", response.data);
            }

            // Handle successful responses (200, 201)
            if (response.status === 200 || response.status === 201) {
                // Show success toast
                MySwal.fire({
                    icon: "success",
                    // title: editMode ? "Mise à jour réussie !" : "Enregistrement réussi !",
                    text: editMode ? "L'étiquette a été modifiée avec succès." : "L'étiquette a été créée avec succès.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });

                // Reset form and close drawer
                resetForm();
                onFormSubmit();
                onClose();
            }

        } catch (error) {
            console.log("Error details:", error.response?.data || error.message);

//             let errorTitle = "Erreur";
            let errorMessage = "Une erreur s'est produite. Veuillez réessayer.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 400:
//                         errorTitle = "Données invalides";
                        if (errorData?.message?.includes("code")) {
                            errorMessage = "Le nom de l'étiquette est requis et ne peut pas être vide.";
                        } else {
                            errorMessage = errorData?.message || "Les données saisies ne sont pas valides. Vérifiez que tous les champs requis sont remplis correctement.";
                        }
                        break;

                    case 401:
//                         errorTitle = "Accès non autorisé";
                        errorMessage = "Votre session a expiré. Veuillez vous reconnecter pour continuer.";
                        break;

                    case 409:
//                         errorTitle = "Conflit de données";
                        errorMessage = "Une étiquette avec ce nom existe déjà. Veuillez choisir un nom différent.";
                        break;

                    case 404:
//                         errorTitle = editMode ? "Étiquette introuvable" : "Ressource introuvable";
                        errorMessage = editMode
                            ? "L'étiquette que vous tentez de modifier n'existe plus ou a été supprimée."
                            : "La ressource demandée est introuvable. Veuillez actualiser la page et réessayer.";
                        break;

                    case 500:
//                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer dans quelques instants.";
                        break;

                    default:
//                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || `Une erreur inattendue s'est produite (Code: ${status}).`;
                }
            } else if (error.request) {
//                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet et réessayez.";
            }

            // Show error toast
            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        } finally {
            setLoading(false);
        }
    };

    const isSystemTag = editMode && etiquetteData?.estSysteme;
    const tagType = etiquetteData?.estSysteme ? 'Système' : 'Personnalisée';
    const platsAssocies = etiquetteData?.plats || 0;

    return (
        <>
            {/* Backdrop */}
            {show && (
                <div
                    className={`drawer-backdrop ${show ? 'show' : ''}`}
                    onClick={onClose}
                ></div>
            )}

            {/* Drawer */}
            <div className={`etiquette-drawer ${show ? 'show' : ''}`}>
                <form onSubmit={handleSubmit}>
                    {/* Header */}
                    <div className="drawer-header">
                        <h4>{editMode ? "Modifier l'étiquette" : "Nouvelle étiquette"}</h4>
                        <button
                            type="button"
                            className="drawer-close-btn"
                            onClick={() => {
                                resetForm();
                                onClose();
                            }}
                        >
                            ×
                        </button>
                    </div>

                    {/* Body */}
                    <div className="drawer-body">
                        {/* Nom de l'étiquette */}
                        <div className="drawer-form-group">
                            <label className="drawer-label drawer-label-required">
                                Nom de l&apos;étiquette
                            </label>
                            <input
                                type="text"
                                name="code"
                                value={formData.code}
                                onChange={handleChange}
                                required
                                disabled={isSystemTag}
                                className="drawer-input"
                                placeholder="Ex: Bar, Cuisine, Pizza..."
                            />
                            {isSystemTag && (
                                <span className="drawer-hint">
                                    Les étiquettes système ne peuvent pas être renommées.
                                </span>
                            )}
                        </div>

                        {/* Interface de préparation (disabled pour l'instant) */}
                        {/* <div className="drawer-form-group">
                            <label className="drawer-label">
                                Interface de préparation
                            </label>
                            <div className="drawer-select-wrapper">
                                <div className="drawer-select-icon">
                                    <BiDrink size={18} />
                                </div>
                                <select
                                    className="drawer-select"
                                    disabled
                                    value={formData.code || "bar"}
                                >
                                    <option value="bar">Bar</option>
                                    <option value="cuisine">Cuisine</option>
                                </select>
                            </div>
                            <span className="drawer-hint">
                                Détermine sur quel écran de préparation les plats apparaîtront.
                            </span>
                        </div> */}

                        {/* Description */}
                        <div className="drawer-form-group">
                            <label className="drawer-label">
                                Description
                            </label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                className="drawer-textarea"
                                placeholder="Ajoutez une description pour cette étiquette (optionnel)"
                            />
                        </div>

                        {/* Statut */}
                        <div className="drawer-status-section">
                            <div className="drawer-status-header">
                                <div>
                                    <div className="drawer-status-title">Statut</div>
                                    <div className="drawer-status-subtitle">
                                        {isActive ? "L'étiquette est active" : "L'étiquette est inactive"}
                                    </div>
                                </div>
                                <label className="drawer-toggle">
                                    <input
                                        type="checkbox"
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                    />
                                    <span className="drawer-toggle-slider"></span>
                                </label>
                            </div>
                        </div>

                        {/* Informations (uniquement en mode édition) */}
                        {editMode && (
                            <div className="drawer-info-section">
                                <div className="drawer-info-title">Informations</div>
                                <div className="drawer-info-item">Plats associés : {platsAssocies}</div>
                                <div className="drawer-info-item">Type : {tagType}</div>
                            </div>
                        )}
                    </div>

                    {/* Footer */}
                    <div className="drawer-footer">
                        <button
                            type="button"
                            className="drawer-btn drawer-btn-secondary"
                            onClick={() => {
                                resetForm();
                                onClose();
                            }}
                        >
                            Annuler
                        </button>
                        <button
                            type="submit"
                            className="drawer-btn drawer-btn-primary"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="drawer-spinner"></span>
                                    {editMode ? "Mise à jour..." : "Enregistrement..."}
                                </>
                            ) : (
                                editMode ? "Enregistrer les modifications" : "Ajouter l'étiquette"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}

AddEtiquette.propTypes = {
    onFormSubmit: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    editMode: PropTypes.bool,
    etiquetteData: PropTypes.object
};

export default AddEtiquette;
